import { fetchAllServiceProviders } from 'Services/ServiceProviderManagement/Features/ServiceProvider/serviceProviderSlice'
import useTypedSelector, { useAppDispatch } from 'Store'
import { SORT_ORDER_ASC } from 'Util/constants'
import { useEffect } from 'react'

const useServiceProviders = () => {
  const dispatch = useAppDispatch()
  const { allServiceProviders, allServiceProvidersLoading } = useTypedSelector(
    state => state.serviceProvider
  )
  const fetchAllServiceProvidersWithoutPagination = () => {
    dispatch(
      fetchAllServiceProviders({
        bypass_pagination: true,
        sort_by: 'serviceProviderId',
        sort_order: SORT_ORDER_ASC
      })
    )
  }

  useEffect(() => {
    fetchAllServiceProvidersWithoutPagination()
  }, [])

  return {
    allServiceProviders,
    allServiceProvidersLoading,
    fetchAllServiceProvidersWithoutPagination
  }
}

export default useServiceProviders
